import { HuitabModal } from '../../../../shared/components/common/huitab-modal';
import { huitabSettings } from '../../../../shared/services/settings-loader';
import { TagCommanderManager } from '../../../../shared/services/tag-commander-manager';

/**
 * La modale pour afficher la plage horaire d'heures creuses pour un compteur <36 kvA
 */
export default class ModalMinimalisteHPHC extends HuitabModal {
  constructor() {
    super('modal-minimaliste-hp-hc');
    const link = this.qs('#link-en-savoir-plus');
    link?.addEventListener('click', () => this.sendTagEnSavoirPlus());
  }

  show(classesTemporellesPuissanceProgrammeeListeString) {
    const list = JSON.parse(classesTemporellesPuissanceProgrammeeListeString);
    if (!Array.isArray(list) || !list.length) return;

    const descriptionEl = this.qs('#description-popin-minimaliste');
    const titleEl = this.qs('#title-heures-creuses');
    const valueEl = this.qs('#valeur-heures-creuses-minimaliste');

    if (!huitabSettings.feature_flipping.affichage_cible_popin_hp_hc) {
      this.element?.setAttribute('popin-provisoire', 'true');
      const heuresCreuses = this.getDisplayValue(
        list?.find((p) => p.typePeriode === 'ANNUELLE')?.programmationHoraireHC,
      );

      this.setHtml(
        descriptionEl,
        `Vous trouverez ci-dessous la grille de programmation des heures creuses du <b>distributeur Enedis</b>.
        Attention, la grille de programmation de votre fournisseur peut être différente.`,
      );
      this.setHtml(valueEl, `${heuresCreuses}`);
      this.setHtml(titleEl, "Plage d'heures creuses");
    } else {
      const hiver = list?.find((p) => p.typePeriode === 'HIVER') ?? {};
      const ete = list?.find((p) => p.typePeriode === 'ETE') ?? {};
      const periodeEte = ete.periodeSaison ?? '';
      const periodeHiver = hiver.periodeSaison ?? '';
      const hcSaisonBasse = this.getDisplayValue(ete.programmationHoraireHCSB);
      const hcSaisonHaute = this.getDisplayValue(hiver.programmationHoraireHCSH);

      this.setHtml(
        descriptionEl,
        `Vous trouverez ci-dessous la grille de programmation des heures creuses du <b>distributeur Enedis.</b>
        <br><br>
        Attention, la grille de programmation de votre fournisseur peut être différente. Nous vous invitons à vous rapprocher de votre fournisseur d'électricité pour connaître les possibilités sur ses offres.`,
      );

      // Colonne "été" déjà présente dans le HTML
      this.setHtml(valueEl, `<lnc-web-icon icon="light_mode" size="20"></lnc-web-icon> ${hcSaisonBasse}`);
      this.setHtml(titleEl, `Heures creuses <b>été</b> : ${periodeEte}`);

      // Ajout colonne "hiver" s'il n'existe pas
      const isColonneHiverCree = this.qs('#hc-hiver-td');
      if (!isColonneHiverCree) {
        this.appendCell('tbody tr', 'td', `<lnc-web-icon icon="ac_unit" size="20"></lnc-web-icon> ${hcSaisonHaute}`, {
          id: 'hc-hiver-td',
        });
        this.appendCell('thead tr', 'th', `Heures creuses <b>hiver</b> : ${periodeHiver}`, { id: 'hc-hiver-th' });
      }
    }

    this.openModal();
  }

  qs(selector) {
    return this.element?.querySelector(selector) ?? null;
  }

  getDisplayValue(value) {
    if (value == null || (typeof value === 'string' && value.trim() === '')) {
      return '<span class="info-non-disponible">Non disponible</span>';
    }
    return value;
  }

  setHtml(el, html) {
    if (!el) return;
    if (typeof el.setHTMLUnsafe === 'function') el.setHTMLUnsafe(html);
    else el.innerHTML = html;
  }

  appendCell(rowSelector, tagName, html, opts = {}) {
    const row = this.element?.querySelector(rowSelector);
    if (!row) return;

    if (opts.id) this.element?.querySelector(`#${opts.id}`)?.remove();

    const cell = document.createElement(tagName);
    if (opts.id) cell.id = opts.id;
    if (opts.className) cell.className = opts.className;
    cell.innerHTML = html;
    row.appendChild(cell);
  }

  sendTagEnSavoirPlus() {
    TagCommanderManager.tagClick({
      chapitre_1: 'mes_compteurs',
      chapitre_2: 'fiche_compteur',
      chapitre_3: 'popup_information_hp_hc',
      page: 'en_savoir_plus',
      type: 'action',
    });
  }

  openModal() {
    if (this.modalRef?.show) {
      this.modalRef.show();
      return;
    }

    const handler = (event) => {
      this.modalRef = event.detail;
      this.element?.removeEventListener('instance', handler);
      this.modalRef?.show?.();
    };

    this.element?.addEventListener('instance', handler);
  }
}
